import axios from 'axios'
import { API_ADDRESS } from 'config'
import { ScrapeQueueState } from 'state/types'

export const getScrapeQueue = async (): Promise<ScrapeQueueState> => {
  const url = `${API_ADDRESS}/admin/scrape-queue/list`
  const { data } = await axios.get(url)

  return data
}

export const clearScrapeQueue = async (): Promise<ScrapeQueueState> => {
  const url = `${API_ADDRESS}/admin/scrape-queue/special`
  const { data } = await axios.get(url)
  return data
}
// callFlushList
